"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBestPair = findBestPair;
const isHandicap_1 = require("../../markets/isHandicap");
const getProbabilityParameterValue_1 = require("../../outcomes/getProbabilityParameterValue");
function findBestPair(outcomes1, outcomes2, marketType, decimalPlaces = 2) {
    let bestPair = [];
    let bestDifference = Infinity;
    outcomes1.forEach((prob1) => {
        outcomes2.forEach((prob2) => {
            // Check if the parameters match based on the market type (handicap or total).
            const parametersMatch = (0, isHandicap_1.isHandicap)(marketType)
                ? matchHandicapParameters(prob1, prob2)
                : matchTotalParameters(prob1, prob2);
            if (parametersMatch) {
                const difference = +Math.abs(prob1.odd - prob2.odd).toFixed(decimalPlaces);
                if (+difference < bestDifference) {
                    bestDifference = +difference;
                    bestPair = [prob1, prob2];
                }
                else if (shouldReplaceBestPair(prob1, bestPair, difference, bestDifference, marketType)) {
                    bestPair = [prob1, prob2];
                }
            }
        });
    });
    return bestPair;
}
function matchHandicapParameters(prob1, prob2) {
    // For handicaps, parameters must be opposite in value.
    return prob1.parameters.every((p1Param) => {
        const p2Param = prob2.parameters.find((p2) => p2.type === p1Param.type);
        return p2Param && Number(p1Param.value) === -Number(p2Param.value);
    });
}
function matchTotalParameters(prob1, prob2) {
    // For totals, parameters must be identical.
    return prob1.parameters.every((p1Param) => {
        const p2Param = prob2.parameters.find((p2) => p2.type === p1Param.type);
        return p2Param && p1Param.value === p2Param.value;
    });
}
function shouldReplaceBestPair(prob, bestPair, difference, bestDifference, marketType) {
    // The logic differs between handicaps and totals:
    // - For handicaps, prioritize pairs with the smallest difference, higher odds and lowest parameter values.
    // - For totals, prioritize pairs with the smallest difference and lowest parameter values.
    if ((0, isHandicap_1.isHandicap)(marketType)) {
        return (difference === bestDifference &&
            (prob.odd > bestPair[0].odd ||
                (prob.odd === bestPair[0].odd &&
                    compareProbsPairByParam([prob], bestPair, (paramA, paramB) => +paramA < +paramB))));
    }
    else {
        return (difference === bestDifference &&
            compareProbsPairByParam([prob], bestPair, (paramA, paramB) => +paramA < +paramB));
    }
}
const compareProbsPairByParam = (probsPairA, probsPairB, compareFunc, probOrder = 0 // compare by the first odd's param by default
) => {
    const paramA = (0, getProbabilityParameterValue_1.getProbabilityParameterValue)(probsPairA[probOrder]);
    const paramB = (0, getProbabilityParameterValue_1.getProbabilityParameterValue)(probsPairB[probOrder]);
    return ((paramA && paramB && compareFunc(paramA.value, paramB.value)) || false);
};
//# sourceMappingURL=findBestPair.js.map